/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { put } from 'redux-saga/effects';

import { APP_AUTH_ERROR_SAGA, showAppError } from '../reducers/app';
import { t } from '../locales/i18n';

function* handleAuthError() {
  yield put(showAppError(t('errors.auth.invalidCredentials'), 15));
  const url = window.location.pathname;
  if (!url.match(/\/settings/i)) {
    console.error('Redirect to /settings');
    //window.location.href = appSettingsPath(action.payload.deviceUUID);
  }
}

export function* authErrorSaga() {
  yield takeLatest(APP_AUTH_ERROR_SAGA, handleAuthError);
}
